
import React, { useEffect, useState } from 'react';
import styles from './ChatAssistant.module.css';

interface ChatButtonProps {
  onClick: () => void;
  hidden?: boolean;
  animatingOut?: boolean;
}


const FloatingChatButton: React.FC<ChatButtonProps> = ({ onClick, hidden, animatingOut }) => {
  const [centered, setCentered] = useState(true);
  const [animatingToRight, setAnimatingToRight] = useState(false);
  const [atRest, setAtRest] = useState(false);
  const ANIM_DURATION = 2000; // ms

  useEffect(() => {
    setCentered(true);
    setAnimatingToRight(false);
    setAtRest(false);
    const timer = setTimeout(() => {
      setAnimatingToRight(true);
      // After animation, set atRest to true
      setTimeout(() => {
        setCentered(false);
        setAnimatingToRight(false);
        setAtRest(true);
      }, ANIM_DURATION);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  let className = styles.floatingChatButton;
  let style: React.CSSProperties = { pointerEvents: hidden ? 'none' : 'auto' };
  if (centered) className += ' ' + styles.floatingChatButtonCenterStart;
  if (animatingToRight) {
    className += ' ' + styles.floatingChatButtonAnimateToRight;
    // style.left = '50%';
        style.left = '95%';
    style.right = 'auto';
  }
  if (atRest) {
    style.left = 'auto';
    style.right = '18px';
    style.transform = 'none';
  }
  if (!centered && !animatingToRight && !atRest) className += ' ' + styles.slideInRight;
  if (animatingOut) className += ' ' + styles.slideOutRight;

  return (
    <button
      onClick={onClick}
      className={className}
      aria-label="Open chat"
      title="Chat with AstroStar"
      tabIndex={hidden ? -1 : 0}
      style={style}

    >
      <span role="img" aria-label="chat">💬</span>
      {/* <span className={styles.floatingChatButtonText}>Ask AstroStar</span> */}
    </button>
  );
};

export default React.memo(FloatingChatButton);
